import React from 'react';

import type { ChallengeCelebration } from '@order/graphql';
import { useTelemetry } from '@order/Telemetry';

export const useChallengesTelemetry = () => {
  const { track } = useTelemetry();

  const handleRewardSelectedTelemetry = React.useCallback(
    (rewardId: string) => {
      track('challenges.reward_selected', { rewardId });
    },
    [track],
  );

  const handleRewardErrorTelemetry = React.useCallback(
    (userError?: string, systemError?: string) => {
      track('challenges.reward_error', { userError, systemError });
    },
    [track],
  );

  const handleMyRewardsTelemetry = React.useCallback(() => {
    track('challenges.my_rewards');
  }, [track]);

  const handleChallengesTermsViewTelemetry = React.useCallback(() => {
    track('challenges.terms_view');
  }, [track]);

  const handleChallengesStartTelemetry = React.useCallback(
    (challengeId: string) => {
      track('challenges.start', { challengeId });
    },
    [track],
  );

  const handleChallengesFailedTelemetry = React.useCallback(
    (userError?: string, systemError?: string) => {
      track('challenges.start_failed', { userError, systemError });
    },
    [track],
  );

  const handleOpenChallengeCelebrationTelemetry = React.useCallback(
    (challenge: ChallengeCelebration) => {
      track('challenges.completed', {
        celebrationCopy: challenge.celebrationCopy,
        challengesIds: challenge.challengesIds,
        expirationDate: challenge.expirationDate,
        title: challenge.title,
      });
    },
    [track],
  );

  const handleCloseChallengeCelebrationTelemetry = React.useCallback(() => {
    track('challenges.closed');
  }, [track]);

  return React.useMemo(
    () => ({
      handleRewardSelectedTelemetry,
      handleRewardErrorTelemetry,
      handleMyRewardsTelemetry,
      handleChallengesTermsViewTelemetry,
      handleChallengesStartTelemetry,
      handleChallengesFailedTelemetry,
      handleOpenChallengeCelebrationTelemetry,
      handleCloseChallengeCelebrationTelemetry,
    }),
    [
      handleRewardSelectedTelemetry,
      handleRewardErrorTelemetry,
      handleMyRewardsTelemetry,
      handleChallengesTermsViewTelemetry,
      handleChallengesStartTelemetry,
      handleChallengesFailedTelemetry,
      handleOpenChallengeCelebrationTelemetry,
      handleCloseChallengeCelebrationTelemetry,
    ],
  );
};
